import Layout from "../../components/Layout";
import { getCookie } from "../../helpers/helpers";
import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import ClipLoader from "react-spinners/ClipLoader";

const TelegramSetup = ({ telegramUsername, setTelegramUsername, onSave, onRefresh }) => {
    const [isEditing, setIsEditing] = useState(!telegramUsername);
    const [showHelp, setShowHelp] = useState(false);

    useEffect(() => {
        // If the username is cleared externally, go back to editing mode.
        if (!telegramUsername) {
            setIsEditing(true);
        }
    }, [telegramUsername]);

    const handleUsernameChange = (e) => {
        const sanitizedValue = e.target.value.replace(/^@/, '').trim();
        setTelegramUsername(sanitizedValue);
    };

    const handleSave = () => {
        onSave();
        // After save is clicked, we want to show the non-editing view.
        if (telegramUsername) {
            setIsEditing(false);
        }
    };

    if (isEditing) {
        return (
            <div>
                <div className="alert alert-info">
                    Pre zapnutie notifikácií je potrebné nastaviť Vaše Telegram meno a spárovať si účet.
                </div>
                <div className="mb-3">
                    <label htmlFor="telegram-username" className="form-label">Telegram Meno (bez @)</label>
                    <input
                        id="telegram-username"
                        value={telegramUsername}
                        onChange={handleUsernameChange}
                        type="text"
                        className="form-control"
                        placeholder="Vaše telegram meno"
                    />
                </div>

                <div className="btn btn-primary" onClick={handleSave}>ULOŽIŤ</div>

                {!showHelp ? (
                    <div className="mt-4">
                        <button className="btn btn-link p-0" onClick={() => setShowHelp(true)}>
                            Kde nájdem Telegram meno?
                        </button>
                    </div>
                ) : (
                    <div className="mt-4">
                        <div className="h5" id="telegram">Kde nájdem Telegram meno/username?</div>
                        <p>Nájdeš ho v Telegram aplikácii v nastaveniach. Ak ho tam nemáš treba si ho vytvoriť.</p>
                        <div className="row d-flex ms-1" style={{ 'maxWidth': '400px' }}>
                            <div className="col p-0 m-0">
                                <img src={require(`../../static/images/telegram1.jpg`)} className="img-fluid w-100 p-0 m-0" alt="Telegram profile settings" style={{ 'minWidth': '150px' }} />
                            </div>
                            <div className="col p-0 m-0">
                                <img src={require(`../../static/images/telegram2.jpg`)} className="img-fluid w-100 p-0 m-0" alt="Telegram username" style={{ 'minWidth': '150px' }} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div>
            <div className="alert alert-light">
                Vaše Telegram meno je nastavené na: <span className="fw-bold">{telegramUsername}</span>.
            </div>

            <div className="alert alert-warning">
                Pre dokončenie spárovania, pošlite správu <span className="text-danger">update</span> na telegram účet <a style={{ 'textDecoration': 'none' }} href="https://t.me/arbitrage_sk_bot">@arbitrage_sk_bot</a>.
                <br />
                Po úspešnom spárovaní sa Vám odomknú filtre pre notifikácie.
            </div>

            <button className="btn btn-secondary" onClick={() => setIsEditing(true)}>Zmeniť meno</button>
            <button className="btn btn-info ms-2" onClick={onRefresh}>Pokračovať</button>
        </div>
    );
};

const NotificationSettings = ({ settings, setSettings, onSave, sites, telegramId }) => {
    const handleSitesChange = (siteId) => {
        const currentIds = settings.sites_ids || [];
        if (currentIds.includes(siteId)) {
            setSettings({ ...settings, sites_ids: currentIds.filter(e => e !== siteId) });
        } else {
            setSettings({ ...settings, sites_ids: [...currentIds, siteId] });
        }
    };
    
    const handleUsernameChange = (e) => {
        const sanitizedValue = e.target.value.replace(/^@/, '').trim();
        setSettings({ ...settings, to: sanitizedValue });
    };

    return (
        <div>
            <div className="row align-items-center">
                <div className="col-auto h5">
                    Telegram Notifikácie:
                </div>
                <div className="col">
                    <div className="form-check form-switch">
                        <input
                            type="checkbox"
                            id="send_notifications"
                            className="form-check-input"
                            checked={settings.notification}
                            onChange={e => setSettings({ ...settings, notification: e.target.checked })}
                        />
                        <label htmlFor="send_notifications" className="form-check-label">
                            {settings.notification ? 'Zapnuté' : 'Vypnuté'}
                        </label>
                    </div>
                </div>
            </div>

            <div className="alert alert-success mt-3">
                Váš Telegram účet je úspešne spárovaný (ID: {telegramId}).
            </div>

            <hr />

            <h5>Filtre pre notifikácie</h5>
            
            <div className="mb-3">
                <label htmlFor="min-roi" className="form-label">Minimálne ROI (%) na upozornenie:</label>
                <input
                    id="min-roi"
                    value={settings.min}
                    onChange={e => setSettings({ ...settings, min: e.target.value })}
                    type="number"
                    className="form-control"
                    placeholder="Zadajte minimálne ROI"
                />
            </div>

            <div className="mb-3">
                <h6>Stávkové spoločnosti:</h6>
                <div className="row">
                    {sites.map(site => (
                        <div className="col-12" key={site.id}>
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    id={`site-${site.id}`}
                                    className="form-check-input"
                                    checked={(settings.sites_ids || []).includes(site.id)}
                                    onChange={() => handleSitesChange(site.id)}
                                />
                                <label htmlFor={`site-${site.id}`} className="form-check-label">{site.name}</label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <hr />

            <div className="mb-3">
                 <label htmlFor="telegram-username-change" className="form-label">Zmeniť Telegram Meno (bez @)</label>
                <input
                    id="telegram-username-change"
                    value={settings.to}
                    onChange={handleUsernameChange}
                    type="text"
                    className="form-control"
                    placeholder="Nové telegram meno"
                />
                 <div className="form-text">Pri každej zmene je potrebné znova spárovať účet (poslať "update" botovi).</div>
            </div>

            <div className="alert alert-warning text-center fw-bold p-2 mt-4">
                Zmeny vo filtroch sa prejavia až po uložení.
            </div>
            <div className="d-grid gap-2">
                <button className="btn btn-primary btn-lg" onClick={onSave}>ULOŽIŤ ZMENY</button>
            </div>
        </div>
    );
};

const Profile = () => {
    const token = getCookie('token');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [dataFetched, setDataFetched] = useState(false);
    const [profile, setProfile] = useState(null);
    const [sites, setSites] = useState([]);
    const [notificationSettings, setNotificationSettings] = useState({
        notification: false,
        to: '',
        min: 0,
        sites_ids: [],
        sports_ids: [],
    });

    const fetchData = useCallback(() => {
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API}/profile/read`,
            data: { token }
        })
            .then(response => {
                const { profile, sites } = response.data;
                setProfile(profile);
                setSites(sites);
                setNotificationSettings({
                    notification: profile.prematch_arbitrage_notification,
                    to: profile.prematch_arbitrage_notification_to || '',
                    min: profile.prematch_arbitrage_notification_min,
                    sites_ids: profile.prematch_arbitrage_notification_sites_ids || [],
                    sports_ids: profile.prematch_arbitrage_notification_sports_ids || [],
                });
                setDataFetched(true);
            })
            .catch(error => {
                if (error.response) {
                    setError(error.response.data.error);
                }
                setDataFetched(true);
            });
    }, [token]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const save = () => {
        setMessage('');
        setError('');
        
        const sanitizedUsername = notificationSettings.to.replace(/^@/, '').trim();

        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API}/profile/update`,
            data: { 
                token, 
                prematch_arbitrage_notification: notificationSettings.notification,
                prematch_arbitrage_notification_to: sanitizedUsername,
                prematch_arbitrage_notification_min: notificationSettings.min,
                prematch_arbitrage_notification_sites_ids: notificationSettings.sites_ids,
                prematch_arbitrage_notification_sports_ids: notificationSettings.sports_ids,
             },
        })
            .then(() => {
                setMessage('Zmeny boli úspešne uložené.');
                fetchData();
            })
            .catch(error => {
                setError(error.response ? error.response.data.error : 'Nastala neznáma chyba.');
            });
    };
    
    if (!dataFetched) {
        return (
            <div className="container d-flex align-items-center justify-content-center" style={{ "height": "calc(100vh - 56px)" }}>
                <ClipLoader color="#000" size={30} margin={5} speedMultiplier={1} />
            </div>
        );
    }

    return (
        <Layout>
            <div className="container-fluid bg-white p-3 h-100" style={{ 'minHeight': '100vh' }}>
                <h3>Nastavenia Notifikácií</h3>
                <hr/>
                
                {message &&
                    <div className="alert alert-success alert-dismissible mt-3" role="alert">
                        {message}
                        <button type="button" className="btn-close" aria-label="close" data-bs-dismiss="alert" onClick={() => setMessage('')}></button>
                    </div>
                }
                 {error &&
                    <div className="alert alert-danger alert-dismissible mt-3" role="alert">
                        {error}
                        <button type="button" className="btn-close" aria-label="close" data-bs-dismiss="alert" onClick={() => setError('')}></button>
                    </div>
                }

                {!profile || !profile.telegram_id ? (
                    <TelegramSetup
                        telegramUsername={notificationSettings.to}
                        setTelegramUsername={(value) => setNotificationSettings({...notificationSettings, to: value})}
                        onSave={save}
                        onRefresh={fetchData}
                    />
                ) : (
                    <NotificationSettings
                        settings={notificationSettings}
                        setSettings={setNotificationSettings}
                        onSave={save}
                        sites={sites}
                        telegramId={profile.telegram_id}
                    />
                )}
            </div>
        </Layout>
    );
};

export default Profile;
